<template>
  <div>
    <el-dialog
      width="60%"
      top="150px"
      title="获取经纬度"
      :before-close="cancel"
      :closable="false"
      :mask-closable="false"
      :visible="visible"
      :close-on-click-modal="false"
      append-to-body
    >
      <span>
        <el-amap-search-box
          class="search-box"
          :search-option="searchOption"
          :on-search-result="querySearch"
        >
        </el-amap-search-box>
        <div id="amap-container" style="width:100%;height:500px;">
          <el-amap
            class="amap-box"
            :vid="'amap-vue1'"
            :center="center"
            :plugin="plugin"
            :events="events"
            :zoom="zoom"
          >
            <el-amap-marker :position="center"></el-amap-marker>
            <el-amap-marker
              v-for="(marker, index) in markersArray"
              :key="'marker' + index"
              :position="marker"
            >
            </el-amap-marker>
            <!-- 地图城市边界配置 -->
            <el-amap-polygon
              :key="idx"
              v-for="(item, idx) in polygonlist"
              v-bind="polygonConfig"
              :path="item.path"
            ></el-amap-polygon>
            <el-amap-polygon
              v-bind="polygonConfig2"
              :path="polygons.De"
            ></el-amap-polygon>
            <el-amap-text
              :key="idx"
              v-for="(item, idx) in polygonlist"
              :position="item.center"
              :text="item['网格']"
            ></el-amap-text>
          </el-amap>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
import geoJson from "./maps.json";
import guanhu from "./guanhu.json";
Vue.use(VueAMap);

export default {
  name: "AMap",
  components: {},
  data() {
    return {
      map: null,
      mapApiKey: "f6a6784aeb8609f7920f60ba3161ae54", //您申请的key值
      markersArray: [116.334529, 39.977991],
      zoom: 15,
      lnglatInfo: {
        lng: "",
        lat: "",
        addr: ""
      },
      searchOption: {
        city: "北京",
        citylimit: true
      },
      center: [116.334529, 39.977991],
      plugin: [
        {
          pName: "Scale",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        },
        {
          pName: "ToolBar",
          position: "RT",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        }
      ],
      events: {
        init(o) {
          // console.log(o.getCenter());
        },
        zoomchange: e => {
          // console.log(e);
        },
        zoomend: e => {
          //获取当前缩放zoom值
          // console.log(this.$refs.map.$$getInstance().getZoom());
          // console.log(e);
        },
        click: e => {
          //地图中的点击事件
          this.center = [e.lnglat.lng, e.lnglat.lat];
          this.markersArray = [];
          this.markersArray.push(this.center);
          this.lnglatInfo.lat = e.lnglat.lat;
          this.lnglatInfo.lng = e.lnglat.lng;
          this.getAddress();
        }
      },
      // 绘制边界
      polygonConfig: {
        // 城市边界 配置
        strokeColor: "#5D87FB", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "#5D87FB", // 遮罩背景色
        fillOpacity: 0.1
      },
      polygonConfig2: {
        // 城市边界 配置
        strokeColor: "#47536e", // 城市边界颜色
        strokeWeight: 2,
        strokeStyle: "dashed", // 线样式
        fillColor: "#47536e", // 遮罩背景色
        fillOpacity: 0.1
      },
      polygons: {
        // 城市边界数据
        De: {}
      },
      district: null,
      polygonlist: []
    };
  },
  props: {
    visible: Boolean
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    // 初始化地图
    init() {
      let _self = this;
      VueAMap.initAMapApiLoader({
        key: _self.mapApiKey,
        plugin: [
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Scale",
          "AMap.OverView",
          "AMap.ToolBar",
          "AMap.MapType",
          "AMap.PolyEditor",
          "AMap.CircleEditor",
          "AMap.Geocoder",
          "AMap.Boundary",
          "AMap.DistrictSearch",
          "AMap.Geolocation",
          "AMap.PlaceSearch",
          "AMap.GeoJSON"
        ],
        // 高德 sdk 版本
        v: "1.4.15"
      });
      // setTimeout(() => {
      //   _self.addGeo()
      //   // _self.addLabel()
      //   // _self.setDistrict()
      // }, 2000)
    },
    // 设置区域边界
    setDistrict() {
      let self = this;
      let district = new window.AMap.DistrictSearch({
        extensions: "all",
        level: "street"
      });
      district.search("龙华", function(status, result) {
        if (status === "complete") {
          self.polygons.De = result.districtList[0].boundaries;
        }
      });
    },
    // 添加名称
    addLabel() {
      let self = this;
      let label = new window.AMap.Label({
        content: "我是一个标签",
        position: [114.0485498231, 22.710759376],
        offset: new window.AMap.Pixel(0, 0)
      });
      self.map.add(label);
    },
    // 添加边界
    addGeo() {
      // 社区边界示例
      geoJson.features.forEach(item => {
        if (item.geometry.coordinates && item.geometry.coordinates.length) {
          this.polygonlist.push({
            path: item.geometry.coordinates,
            ...item.properties,
            center: item.geometry.coordinates[0][0]
          });
        }
      });
      // 街道边界
      this.polygons.De = guanhu.features[0].geometry.coordinates;
    },
    //根据经纬度获取地址
    getAddress() {
      let self = this;
      let geocoder = new window.AMap.Geocoder({
        radius: 50, // 范围，默认：500
        extensions: "base",
        city: "北京市" // 设置搜索城市为北京
      });
      geocoder.getAddress(self.center, function(status, result) {
        if (status === "complete" && result.info === "OK") {
          if (result && result.regeocode) {
            self.lnglatInfo.addr = result.regeocode.formattedAddress;
            self.$emit("map-confirm", self.lnglatInfo);
            self.$nextTick();
          }
        }
      });
    },
    //点击搜索后触发的事件
    querySearch(pois) {
      console.log(pois, "pois");
      this.input = document.querySelector(".search-box-wrapper input").value;
      this.center = [pois[0].lng, pois[0].lat]; //选择了第一个值
      this.markersArray = []; //标记点先清空
      this.markersArray.push([pois[0].lng, pois[0].lat]); //把搜索的位置的第一个值存入标记中并显示标记点
      this.lnglatInfo.lat = pois[0].lat;
      this.lnglatInfo.lng = pois[0].lng;
      this.getAddress();
    },
    /***
     * 确认，并返回选择的经纬度
     */
    confirm: function() {
      this.$emit("map-confirm", this.lnglatInfo);
    },
    /***
     * 取消
     */
    cancel: function() {
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.amap-logo {
  right: 0 !important;
  left: auto !important;
  display: none !important;
}

/deep/.amap-copyright {
  right: 70px !important;
  left: auto !important;
  opacity: 0 !important;
}

.serachinput {
  width: 300px;
  box-sizing: border-box;
  padding: 9px;
  border: 1px solid #dddee1;
  line-height: 20px;
  font-size: 16px;
  height: 38px;
  color: #333;
  position: relative;
  border-radius: 4px;
  -webkit-box-shadow: #666 0px 0px 10px;
  -moz-box-shadow: #666 0px 0px 10px;
  box-shadow: #666 0px 0px 10px;
}

/deep/ .el-dialog__header {
  border-bottom: 0 !important;
}

.search-box {
  width: 100%;
  height: 40px;
}

/deep/ .el-vue-search-box-container .search-box-wrapper .search-btn {
  background-color: #409eff;
  border-color: #409eff;
  color: #fff;
  width: 70px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/deep/ .el-vue-search-box-container .search-box-wrapper input {
  height: 40px;
  line-height: 40px;
  border: 1px solid #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/map-search/index.vue